import React from 'react';
import PropTypes from 'prop-types';
import Spreadsheet from '../../../Spreadsheet';

const SpreadsheetFilter = ({ onChange, value }) => {
  const handleChange = data => {
    if (onChange && typeof onChange === 'function') {
      const formattedData = (data ?? []).reduce(
        (acc, columnData) => [...acc, ...Object.values(columnData)],
        [],
      );
      onChange({}, formattedData);
    }
  };

  const formattedValue = (value ?? []).reduce((acc, item) => [...acc, { 0: item }], []);

  return (
    <Spreadsheet
      height={240}
      startRows={10}
      startCols={1}
      showColHeaders={false}
      onChange={handleChange}
      data={value?.length ? formattedValue : null}
    />
  );
};

SpreadsheetFilter.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.array,
};

SpreadsheetFilter.defaultProps = {
  onChange: undefined,
  value: [],
};

export default SpreadsheetFilter;
